"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layouts = require("layouts");
var Snippets = require("snippets");
var BlogTemplate = /** @class */ (function (_super) {
    __extends(BlogTemplate, _super);
    function BlogTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this.buildPlaceholders = function (limit) {
            var placeholders = [];
            var repeat = i % 9;
            var ratio = repeat == 1 || repeat == 4 || repeat == 7 ? "1:1" : repeat == 2 || repeat == 3 || repeat == 6 ? "2:1" : "3:2";
            for (var i = 0; i < limit; i++) {
                placeholders.push(React.createElement("div", { key: i, className: "w-full md:px-3-5 md:w-1/3 pb-3-4 md:pb-1-6 md:border-r " + (i % 3 < 2 ? "border-grey-light" : "border-transparent") },
                    React.createElement("div", { className: "ratio-" + ratio + " content-placeholder" }),
                    React.createElement("div", { className: "py-2-4 px-0-8 flex flex-col items-center" },
                        React.createElement("p", { className: "content-placeholder w-1/3 py-1" }),
                        React.createElement("p", { className: "content-placeholder w-full py-0-7 mt-1" }),
                        React.createElement("p", { className: "content-placeholder w-1/2 py-0-7 mt-0-5" }),
                        React.createElement("p", { className: "content-placeholder w-1/4 py-0-7 mt-2-4" }))));
            }
            return placeholders;
        };
        var blog = _this.props.data.blog;
        _this.state = {
            articles: blog.articles,
            current_page: 1,
            loading: 0
        };
        return _this;
    }
    BlogTemplate.prototype.componentDidMount = function () {
        var paginate = this.props.data.paginate;
        this.setState({
            current_page: paginate.current_page
        });
    };
    BlogTemplate.prototype.render = function () {
        var _this = this;
        var _a = this.state, articles = _a.articles, loading = _a.loading;
        var _b = this.props.data, blog = _b.blog, paginate = _b.paginate, linklist = _b.linklist, section = _b.section;
        var settings = section.blog.settings;
        var categories = blog && blog.all_tags && blog.all_tags.filter(function (tag) { return tag.includes("category:"); }).length
            ? blog.all_tags.filter(function (tag) { return tag.includes("category:"); })
            : null;
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement(Snippets.Container, { width: "lg", tag: "section", className: "pt-1-6 md:pt-2-4 pb-4" },
                React.createElement("div", { className: "hidden md:flex items-center justify-center" },
                    React.createElement(Snippets.Heading, { size: "h1", className: "leading-none uppercase text-charcoal-dark font-medium text-3xl" }, blog.title)),
                settings.article && !blog.current_tags ? (React.createElement("div", { className: "md:border-t border-midnight md:pt-2-4 md:mt-2-4" },
                    React.createElement(Snippets.BlogArticle, { article: settings.article, ratio: "9:4", className: "hidden md:block", style: "featured" }),
                    React.createElement(Snippets.BlogArticle, { article: settings.article, ratio: "2:3", className: "block md:hidden", style: "featured" }))) : null,
                React.createElement("nav", { className: "flex items-center justify-between border-t border-b border-midnight mt-1-6 md:mt-2-4" },
                    React.createElement("div", { className: "w-1/6 hidden md:block" }),
                    React.createElement("ul", { className: "list-reset flex w-full md:w-2/3 items-center justify-start md:justify-center md:-mx-1-8 py-1-6 leading-none overflow-x-auto md:overflow-x-hidden overflow-y-hidden" }, categories && categories.length ? (React.createElement(React.Fragment, null,
                        React.createElement("li", { className: "block mr-3-2 md:mx-1-8" },
                            React.createElement("a", { href: blog.url, title: "All", className: "block font-mono capitalize italic tracking-wide text-sm text-midnight hover:text-charcoal whitespace-no-wrap transition-fast" + (!blog.current_tags ? " line-through" : "") }, "All")),
                        categories.map(function (category, i) { return (React.createElement("li", { key: i, className: "block mr-3-2 md:mx-1-8" },
                            React.createElement("a", { href: blog.url + "/tagged/" + category.replace(/:|\s/g, "-").toLowerCase().trim(), title: category.replace("category:", ""), className: "block font-mono capitalize italic tracking-wide text-sm text-midnight hover:text-charcoal whitespace-no-wrap transition-fast" + (blog.current_tags == category ? " line-through" : "") }, category.replace("category:", "")))); }))) : null),
                    React.createElement("div", { className: "w-1/6 hidden md:block" })),
                React.createElement("div", { className: "mt-1-6 md:mt-3-4" },
                    React.createElement("div", { className: "md:-mx-3-5 md:flex flex-wrap" + (articles && articles.length < 3 ? " justify-center" : "") },
                        articles && articles.length
                            ? articles.map(function (article, i) {
                                var repeat = i % 9;
                                var ratio = repeat == 1 || repeat == 4 || repeat == 7 ? "1:1" : repeat == 2 || repeat == 3 || repeat == 6 ? "2:1" : "3:2";
                                return (React.createElement(Snippets.BlogArticle, { key: i, article: article, className: "w-full md:px-3-5 md:w-1/3 md:border-r" + (!(i == articles.length - 1 && articles.length == blog.articles_count) ? " pb-3-4 md:pb-1-6" : "") + " " + (i % 3 < 2 && !((i === 0 && articles.length < 2) || (i === 1 && articles.length < 3))
                                        ? "border-grey-light"
                                        : "border-transparent"), ratio: ratio }));
                            })
                            : null,
                        loading ? this.buildPlaceholders(loading) : null),
                    articles.length < blog.articles_count && !loading ? (React.createElement("div", { className: "flex items-center justify-center md:mt-4-8" },
                        React.createElement(Snippets.Button, { className: "w-17-8", onClick: function () {
                                return _this.fetchArticles(blog.articles_count - articles.length > paginate.page_size
                                    ? paginate.page_size
                                    : blog.articles_count - articles.length);
                            } }, "Load " + (blog.articles_count - articles.length) + " More"))) : null))));
    };
    BlogTemplate.prototype.fetchArticles = function (count) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, articles, current_page;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state, articles = _a.articles, current_page = _a.current_page;
                        this.setState({
                            loading: count
                        });
                        return [4 /*yield*/, fetch("?view=json&page=" + (current_page + 1))
                                .then(function (response) { return response.json(); })
                                .then(function (result) {
                                _this.setState({
                                    articles: articles.concat(result.articles),
                                    current_page: current_page + 1,
                                    loading: 0
                                });
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return BlogTemplate;
}(React.Component));
exports.BlogTemplate = BlogTemplate;
